import { computed, reactive } from '@vue/composition-api';

import smh, { SMH } from '@/renderer/scripts/smh';
import tips from '@/renderer/scripts/utils/tips';

interface CoSpaceListData {
  checked: boolean;
  name: string;
  spaceId: SMH.SpaceId;
}

interface CoData {
  list: CoSpaceListData[];
  checked: SMH.SpaceId[];
  coSpaceChecked: boolean;
}

export default function handler() {
  const coData = reactive<CoData>({
    list: [],
    checked: [],
    coSpaceChecked: true,
  });
  const coIndeterminate = computed(() => {
    const checked = coData.list.filter(item => item.checked);
    return checked.length < coData.list.length && checked.length !== 0;
  });
  const coSpaceItems = computed(() => {
    return coData.list
      .filter(item => item.checked)
      .map(item => {
        return {
          spaceId: item.spaceId,
          includeChildSpace: false,
        } as SMH.SpaceItem;
      });
  });

  const methods = {
    async initData() {
      Object.assign(coData, {
        list: [],
        checked: [],
        coSpaceChecked: true,
      });
      await methods.getCoList();
    },
    // 获取群组列表的数据
    async getCoList() {
      const opt = {
        page: 1,
        pageSize: 1000,
        // 拿到尽可能多的群组数据
        withFileCount: 0,
        withDirectory: 0,
        // adminOnly: 1, // 过滤无权限的群组
      };

      coData.checked = [];
      coData.list = [];
      try {
        const { data } = await smh.userAPI.listCollaborationSpaces(opt);
        data.contents.forEach(item => {
          const temp = {
            checked: true,
            name: item.name,
            spaceId: item.spaceId,
          };
          coData.list.push(temp);
          coData.checked.push(item.spaceId);
        });
      } catch (e) {
        tips.error(e as MsgError);
      }
    },
    triggerCoSpaceChecked() {
      coData.coSpaceChecked = !coData.coSpaceChecked;
      coData.list.forEach(item => {
        item.checked = coData.coSpaceChecked;
      });
    },
    changeCoSpaceItemChecked(item: CoSpaceListData) {
      const findItem = coData.list.find(o => o.spaceId === item.spaceId);
      if (findItem) {
        findItem.checked = !findItem.checked;
      }
    },
  };

  return {
    coData,
    coSpaceItems,
    coIndeterminate,
    methods,
  };
}
